import { useCallback, useEffect, useState } from 'react';
import { fetchPaymentInfo, PaymentInfoResponse } from './api/paymentInfo';

/**
 * Datos de cobro de la psicóloga logueada (GET /api/psychologist/payment-info,
 * proxeado por psiplatform-be hacia psima). Sin cache propia: se pide en cada
 * montaje de la sección — el volumen de tráfico es bajo y es preferible ver el
 * dato recién guardado al instante (mismo criterio que useKnowledgeBase).
 */
export function usePaymentInfo() {
  const [info, setInfo] = useState<PaymentInfoResponse | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);

  const load = useCallback(() => {
    setIsLoading(true);
    setError(false);
    fetchPaymentInfo()
      .then(setInfo)
      .catch(() => setError(true))
      .finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    load();
  }, [load]);

  return { info, isLoading, error, refetch: load, setInfo };
}
